// extracted by mini-css-extract-plugin
export default {"container":"ModularConfiguratorPage__container___et1xd","configurator":"ModularConfiguratorPage__configurator___GKIqm"};